export default {
  "en": {
    "question": {
      "actions": {
        "addDocuments": "Add documents",
        "cancel": "Cancel",
        "createQuestion": "Create question",
        "delete": "Delete",
        "deleteDocuments": "Delete documents",
        "edit": "Edit",
        "new": "New question",
        "save": "Save"
      },
      "attributes": {
        "answer": "Answer",
        "documents": "Documents / Images",
        "name": "Question",
        "question": "Question"
      },
      "labels": {
        "editQuestion": "Edit Question",
        "newQuestion": "New Question"
      },
      "toasts": {
        "create": "Question created",
        "delete": "Question deleted",
        "update": "Question updated"
      },
      "validation": {
        "needAnswer": "Answer required",
        "needQuestion": "Question required"
      }
    }
  }
}